import { Box, Grid, Stack, Wrapper } from 'designsystem';
import { FC, ReactNode } from 'react';

const PageSection: FC<{ children: ReactNode }> = ({ children }) => (
    <Wrapper>
        <Grid>
            <Box gridColumn={['1 / -1', null, '1 / span 9', '1 / span 8', '1 / span 7']}>
                <Stack spacing={6}>{children}</Stack>
            </Box>
        </Grid>
    </Wrapper>
);

export default PageSection;
